//:todo: I need to check why is lRefferer and Ireferrer not working Usource is not working

import React, {
    useState,
    useContext,
    FormEvent,
    useEffect,
    useRef,
} from 'react';
import { graphql, navigate } from 'gatsby';
//@ts-ignore
import * as styles from './form-masthead.module.css';
import CtaLink from '../Global/CtaLink';
import { BuildLinkHref } from '../Global/BuildLinkHref';
//@ts-ignore
import RichText from '../Global/RichText';
import {
    KontentStringValue,
    CTAConfiguration,
    GeneralImages,
    KontentRadioMultiChoice,
    KontentMedia,
    BrandColor,
    KontentNumberValue,
    CtaTsType,
    KontentStringCodenameValue,
    KontentRichText,
    GetPricingForm,
} from '../../../types/KontentProps';
import { getColor, getMediaData, getMultiChoice } from '../Global/DataUtils';
import { getImageData } from '../Global/DataUtils/gatsbyImageUtils';
import ArtDirectedImage from '../Global/ArtDirectedImage';
import LazyImage from '../Global/LazyImage';
import CustomHeadline from '../Global/CustomHeadline';
import { allCountryPhoneNumberCodes } from '../../global/countries';
import { PageMetadataContext } from '../../templates/PageMetaDataContext';
import useCookieTracking from '../Global/useCookieTracking';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getIpLocation } from '../../utils/ipLocation';

type ShowHide = 'show' | 'hide';
interface Props extends CTAConfiguration, GeneralImages {
    kontentItemId?: string;
    component_anchor_name: KontentStringValue;
    cta_show_or_hide: KontentRadioMultiChoice<ShowHide>;
    description_copy: KontentStringValue;
    description_tag: KontentStringCodenameValue;
    display_headline: KontentStringValue;
    display_headline_tag: KontentStringCodenameValue;
    display_sub_headline: KontentStringValue;
    display_sub_headline_tag: KontentStringCodenameValue;
    text_background_color: BrandColor;
    text_background_opacity: KontentNumberValue;
    form_headline: KontentStringValue;
    form: {
        value: {
            elements: GetPricingForm;
        }[];
    };
    sub_headline_style?: KontentStringCodenameValue;
    description_style?: KontentStringCodenameValue;
}

const FormMasthead: React.FC<Props> = ({
    component_anchor_name,
    cta_configuration__cta_label,
    cta_configuration__cta_location,
    cta_configuration__cta_location_anchor_point,
    cta_configuration__cta_window_action,
    cta_show_or_hide,
    description_copy,
    description_tag,
    display_headline,
    display_headline_tag,
    display_sub_headline,
    display_sub_headline_tag,
    general_large___small_image_selection__large,
    general_large___small_image_selection__small,
    text_background_color,
    text_background_opacity,
    form_headline,
    form,
    sub_headline_style,
    description_style,
    kontentItemId,
    ...props
}) => {
    const pageMetadata = useContext(PageMetadataContext);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [phoneNumber, setPhoneNumber] = useState<string>('');
    const [selectedCountry, setSelectedCountry] =
        useState<any>('United States');
    const [firstNameErr, setFirstNameErr] = useState(false);
    const [lastNameErr, setLastNameErr] = useState(false);
    const [emailErr, setEmailErr] = useState(false);
    const [phoneNumberErr, setPhoneNumberError] = useState(false);
    const [countryCode, setCountryCode] = useState<string>('');
    const [phoneNumberLength, setPhoneNumberLength] = useState<number>(15);
    const [promoCode, setPromocode] = useState('');

    const firstNameRef = useRef<HTMLInputElement>(null);
    const lastNameRef = useRef<HTMLInputElement>(null);
    const emailRef = useRef<HTMLInputElement>(null);
    const phoneNumberRef = useRef<HTMLInputElement>(null);
    const mobileFirstNameRef = useRef<HTMLInputElement>(null);
    const mobileLastNameRef = useRef<HTMLInputElement>(null);
    const mobileEmailRef = useRef<HTMLInputElement>(null);
    const mobileNumberRef = useRef<HTMLInputElement>(null);
    const [ipAddress, setIpAddress] = useState('');
    const [submitBtnLoading, setSubmitBtnLoading] = useState(false);

    const subHeadlineStyle = sub_headline_style?.value[0]?.codename;
    const descriptionStyle = description_style?.value[0]?.codename;

    const { GATSBY_API_URL } = process.env;
    const ctaWindowAction = getMultiChoice(
        cta_configuration__cta_window_action
    );
    const PhoneNumberCodes = allCountryPhoneNumberCodes;
    const formElements = form.value[0].elements;
    const formCtaWindowAction = getMultiChoice(
        formElements.cta_configuration__cta_window_action
    );
    const formCtaHref = formElements
        .cta_configuration__cta_location_anchor_point?.value
        ? BuildLinkHref(formElements.cta_configuration__cta_location) +
          '#' +
          formElements.cta_configuration__cta_location_anchor_point?.value
        : BuildLinkHref(formElements.cta_configuration__cta_location);

    const handleCountryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedCountry(e.target.value);
        setCountryCode(PhoneNumberCodes[e.target.value].phoneCode);
        setPhoneNumber(PhoneNumberCodes[e.target.value].phoneCode);
    };

    const ctaShowHide =
        getMultiChoice(cta_show_or_hide) === 'show' &&
        cta_configuration__cta_label?.value;
    const textBackgroundColor = getColor(text_background_color);
    const textBackgroundOpacity = text_background_opacity?.value
        ? text_background_opacity.value / 100
        : 1;

    const renderImages = () => {
        const largeImageData = getImageData(
            general_large___small_image_selection__large
        );
        const smallImageData = general_large___small_image_selection__small
            ?.value[0]
            ? getImageData(general_large___small_image_selection__small)
            : null;

        if (!largeImageData?.image) return null;

        const sources = [];
        if (smallImageData?.image) {
            sources.push({
                url: smallImageData.image.url,
                media: '(max-width: 576px)',
                width: 720,
                height: 1080,
            });
            sources.push({
                url: largeImageData.image.url,
                media: '(max-width: 1024px)',
                width: 1024,
                height: 700,
            });
        }
        sources.push({
            url: largeImageData.image.url,
            media: smallImageData?.image
                ? '(min-width: 1025px)'
                : '(min-width: 1px)',
            width: 1920,
            height: 988,
        });

        return (
            <ArtDirectedImage
                sources={sources}
                fallback={{
                    url: largeImageData.image.url,
                    width: 1920,
                    height: 988,
                }}
                alt={largeImageData.alt}
                className={styles.picture}
                style={{ overflow: 'visible' }}
                imgStyle={{ height: '100%' }}
                loading="eager"
                fetchPriority="high"
                elementCodename="general_large___small_image_selection__large"
            />
        );
    };

    const [honeyPotValue, setHoneyPotValue] = useState('');
    const cookieTrackingData = useCookieTracking(); // Assign the hook's return value to a variable

    React.useEffect(() => {
        getIpLocation().then((data) => {
            if (!data || !data.country_code) {
                setSelectedCountry('United States');
                setCountryCode(PhoneNumberCodes['United States'].phoneCode);
                setPhoneNumber(PhoneNumberCodes['United States'].phoneCode);
                return;
            }

            const matchedCountry = Object.entries(
                allCountryPhoneNumberCodes
            ).find(([, value]) => value.countryCode === data.country_code);

            if (matchedCountry) {
                const [countryName, info] = matchedCountry;
                setSelectedCountry(countryName);
                setCountryCode(info.phoneCode);
                setPhoneNumber(info.phoneCode);
            } else {
                setSelectedCountry('United States');
                setCountryCode(PhoneNumberCodes['United States'].phoneCode);
                setPhoneNumber(PhoneNumberCodes['United States'].phoneCode);
            }
            setIpAddress(data.ip);
        });
    }, []);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const mbsyValue = params.get('mbsy');
        if (mbsyValue) {
            setPromocode(mbsyValue);
        } else {
            if (!promoCode) {
                let doc = typeof document !== 'undefined' ? document : null;
                const cookie: any = doc
                    ? doc.cookie
                          .split('; ')
                          .reduce((prev: any, current: any) => {
                              const [name, ...value] = current.split('=');
                              prev[name] = value.join('=');
                              return prev;
                          }, {})
                    : '';
                cookie['promocode'] ? setPromocode(cookie['promocode']) : null;
            }
        }
    }, []);

    useEffect(() => {
        let totalLenth =
            countryCode == '+1' || countryCode == '+44'
                ? countryCode.length + 5 + 10
                : countryCode.length + 10;
        setPhoneNumberLength(totalLenth);
    }, [countryCode]);

    const dumpFormDataToDB = async (payload: any) => {
        try {
            const response = await fetch(
                `https://api.sunlighten.com/customForm/addGetPricingUserData`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(payload),
                }
            );

            const result = await response.json();
            if (response.ok) {
                console.log('Form submitted successfully:', result);
                return { result: true, message: 'Form submitted successfully' };
            } else {
                console.error('Submission failed:', result);
                return {
                    result: false,
                    message: 'Failed to save details of the form',
                };
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            return {
                result: false,
                message:
                    'Error occured while submitting the form to the database',
            };
        }
    };

    const sendDataToSalesForce = async (payload: any) => {
        try {
            const response = await fetch(
                `https://hooks.zapier.com/hooks/catch/3762259/2a6vx3f/`,
                {
                    method: 'POST',
                    headers: {},
                    body: JSON.stringify({ form: payload.data }),
                }
            );

            const result = await response.json();

            if (response.ok) {
                return {
                    result: true,
                    message: 'Get Pricing form submitted successfully!',
                };
            } else {
                console.error('Submission failed:', result);
                return {
                    result: false,
                    message: result.message || 'Failed to submit form.',
                };
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            return {
                result: false,
                message: 'Error submitting form. Please try again.',
            };
        }
    };

    const notify = (msg: string) =>
        toast.error(msg, {
            position: 'bottom-center',
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
        });

    const submitForm = async () => {
        const payload = {
            formName: 'GetPricingMastheadForm',
            data: {
                formName: 'GetPricingMastheadForm',
                firstName,
                lastName,
                email,
                phoneNumber,
                selectedCountry,
                countryCode,
                promoCode,
                ipAddress,
                ...cookieTrackingData,
            },
        };

        const salesforceResp = await sendDataToSalesForce(payload);
        const DBSubmitFlag = await dumpFormDataToDB(payload);
        if (salesforceResp.result) {
            if (DBSubmitFlag.result == false) {
                notify(DBSubmitFlag.message);
            }

            formCtaWindowAction === 'new_window'
                ? window.open(formCtaHref, '_blank', 'noopener,noreferrer')
                : navigate(formCtaHref);
        } else {
            notify('Error occured while submitting the form');
        }
    };

    const validateFormInputs = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (submitBtnLoading) return;
        if (!firstName) {
            window.innerWidth >= 1302
                ? firstNameRef.current?.focus()
                : mobileFirstNameRef.current?.focus();
            setFirstNameErr(true);
            return;
        } else if (!lastName) {
            setLastNameErr(true);
            window.innerWidth >= 1302
                ? lastNameRef.current?.focus()
                : mobileLastNameRef.current?.focus();
            return;
        } else if (!phoneNumber || phoneNumber.length < phoneNumberLength) {
            setPhoneNumberError(true);
            window.innerWidth >= 1302
                ? phoneNumberRef.current?.focus()
                : mobileNumberRef.current?.focus();
            return;
        } else if (
            !email ||
            !email.match(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/)
        ) {
            setEmailErr(true);
            window.innerWidth >= 1302
                ? emailRef.current?.focus()
                : mobileEmailRef.current?.focus();
            return;
        }

        if (honeyPotValue) {
            // Potential bot submission
            alert('Spam detected!');
            return;
        }

        // Phone Number Length Validation
        const countryCode = PhoneNumberCodes[selectedCountry]?.phoneCode;
        if (!countryCode) {
            alert('Invalid country selected.');
            return;
        }

        const expectedPhoneLength = countryCode.length + 10;
        if (phoneNumber.replace(/\D/g, '').length + 1 !== expectedPhoneLength) {
            // +1 for the country code "+" sign"
            setPhoneNumberError(true);
            return;
        }
        try {
            setSubmitBtnLoading(true);
            await submitForm();
            setSubmitBtnLoading(false);
        } catch (err) {
            console.log(err);
            notify('Error occured while submitting the form');
            setSubmitBtnLoading(false);
        }
        // If validation passes, proceed with form submission (e.g., send data to an API)
    };

    const formatPhoneNumber = (value: string) => {
        if (
            value.length < countryCode.length ||
            !value.startsWith(countryCode)
        ) {
            setPhoneNumber(countryCode);
            return;
        } else if (value.replace(/[()\s]/g, '') === countryCode) {
            setPhoneNumber(value);
            return;
        }
        if (countryCode == '+1' || countryCode == '+44') {
            let countryCodeLength = countryCode.length;
            let strippedPhoneNumber = Number(value.replace(/[+()-\s]/g, ''));
            let PhoneNumberArray = strippedPhoneNumber.toString().split('');
            PhoneNumberArray.splice(countryCodeLength - 1, 0, ' (');
            PhoneNumberArray.splice(countryCodeLength + 3, 0, ') ');
            if (PhoneNumberArray.length > countryCodeLength + 7) {
                PhoneNumberArray.splice(countryCodeLength + 7, 0, '-');
            }
            const formattedPhoneNumber = `+${PhoneNumberArray.join('')}`;
            setPhoneNumber(formattedPhoneNumber);
        } else {
            setPhoneNumber(value);
        }
    };

    function handlePhoneNumberChange(e: React.ChangeEvent<HTMLInputElement>) {
        setPhoneNumberError(false);
        let { value, selectionStart } = e.target;
        const cursorPosition = (selectionStart ?? 0) - 1;
        const typedChar = value[cursorPosition] || '';
        const inputEvent = e.nativeEvent as InputEvent;
        const inputType = inputEvent.inputType;
        // Check if the typed character is not a number and is not a backspace
        if (
            isNaN(Number(typedChar)) &&
            typedChar !== '' &&
            inputType !== 'deleteContentBackward'
        ) {
            console.log('Invalid input, not a number:', typedChar);
            return;
        }

        let strippedValue = value.replace(/[+()-\s]/g, '').trim();
        if (
            !value.startsWith(countryCode) &&
            e.target.defaultValue.startsWith(countryCode)
        ) {
            return;
        }
        const isInvalidLength =
            value.length < countryCode.length ||
            (['+1', '+44'].includes(countryCode) &&
                strippedValue.length > countryCode.length + 9) ||
            (!['+1', '+44'].includes(countryCode) &&
                strippedValue.length > countryCode.length + 9);

        if (isInvalidLength) {
            return;
        } else {
            //check if any special character was removed
            if (
                e.target.defaultValue.replace(/[\s]/g, '') ===
                value.replace(/[\s]/g, '')
            ) {
                value = value.slice(0, -2);
                if (charactersNotLessThanCountryCode(value)) {
                    formatPhoneNumber(value);
                }
                return;
            } else if (
                e.target.defaultValue.replace(/[()]/g, '') ===
                value.replace(/[()]/g, '')
            ) {
                value = value.slice(0, -2);
                if (charactersNotLessThanCountryCode(value)) {
                    formatPhoneNumber(value);
                }
                return;
            } else if (
                e.target.defaultValue.replace(/[-]/g, '') ===
                value.replace(/[-]/g, '')
            ) {
                value = value.slice(0, -1);
                if (charactersNotLessThanCountryCode(value)) {
                    formatPhoneNumber(value);
                }
                return;
            }

            formatPhoneNumber(value);
        }
    }

    const charactersNotLessThanCountryCode = (
        phoneCharacters: String
    ): Boolean => {
        if (phoneCharacters.length < countryCode.length) {
            setPhoneNumber(countryCode);
            return false;
        }
        return true;
    };

    const renderErrorMessage = (message: string = 'This field is required') => {
        return (
            <div className={styles.errorMessageBox}>
                <div>
                    <LazyImage
                        src="https://cdn.jotfor.ms/images/exclamation-octagon.png"
                        alt="Error"
                        width={18}
                        height={18}
                    />
                    <p className={styles.errorMessage}>{message}</p>
                    <div className={styles.errorMessageBoxTriangle}></div>
                </div>
            </div>
        );
    };

    const fetchHeadlineStyle = (headlineStyle: String) => {
        if (headlineStyle == 'small') {
            return 'h5';
        } else if (headlineStyle == 'medium') {
            return 'h4';
        } else {
            return 'h3';
        }
    };

    const renderGetPricingForm = (
        firstNameRef: React.RefObject<HTMLInputElement>,
        lastNameRef: React.RefObject<HTMLInputElement>,
        emailRef: React.RefObject<HTMLInputElement>,
        phoneNumberRef: React.RefObject<HTMLInputElement>
    ) => {
        return (
            <form onSubmit={validateFormInputs}>
                <div className={styles.formInnerWrapper}>
                    <div className={styles.rowContainer}>
                        <div className={styles.formGroup}>
                            <label
                                className={`${styles.textLabel} ${
                                    formElements?.first_name?.value.includes(
                                        '*'
                                    )
                                        ? styles.requiredField
                                        : ''
                                }`}
                                htmlFor="firstName"
                                data-kontent-element-codename="first_name"
                            >
                                {formElements?.first_name?.value.replace(
                                    '*',
                                    ''
                                )}
                            </label>
                            <input
                                type="text"
                                id="firstName"
                                className={`${
                                    firstNameErr ? styles.errorBorder : ''
                                }`}
                                name="firstName"
                                onChange={(e) => {
                                    e.target.value.length > 0
                                        ? setFirstNameErr(false)
                                        : setFirstNameErr(true);
                                    setFirstName(e.target.value);
                                }}
                                ref={firstNameRef}
                            />
                            {firstNameErr && renderErrorMessage()}
                        </div>
                        <div className={styles.formGroup}>
                            <label
                                className={
                                    styles.textLabel +
                                    ' ' +
                                    (formElements?.last_name?.value.includes(
                                        '*'
                                    )
                                        ? styles.requiredField
                                        : '')
                                }
                                htmlFor="lastName"
                                data-kontent-element-codename="last_name"
                            >
                                {formElements?.last_name?.value.replace(
                                    '*',
                                    ''
                                )}
                            </label>
                            <input
                                type="text"
                                id="lastName"
                                name="lastName"
                                className={`${
                                    lastNameErr ? styles.errorBorder : ''
                                }`}
                                onChange={(e) => {
                                    e.target.value.length > 0
                                        ? setLastNameErr(false)
                                        : setLastNameErr(true);
                                    setLastName(e.target.value);
                                }}
                                ref={lastNameRef}
                            />
                            {lastNameErr && renderErrorMessage()}
                        </div>
                    </div>
                    <div className={styles.rowContainer}>
                        <div className={`${styles.formGroup}`}>
                            <label
                                htmlFor="country"
                                className={
                                    styles.textLabel +
                                    ' ' +
                                    (formElements?.select_country?.value.includes(
                                        '*'
                                    )
                                        ? styles.requiredField
                                        : '')
                                }
                                data-kontent-element-codename="select_country"
                            >
                                {formElements?.select_country?.value.replace(
                                    '*',
                                    ''
                                )}
                            </label>
                            <select
                                id="country"
                                className={styles.countrySelect}
                                value={selectedCountry}
                                onChange={handleCountryChange}
                            >
                                {Object.entries(allCountryPhoneNumberCodes).map(
                                    ([country, countryValue]) => {
                                        return (
                                            <option
                                                key={country}
                                                value={country}
                                            >
                                                {country +
                                                    ' ' +
                                                    countryValue.phoneCode}
                                            </option>
                                        );
                                    }
                                )}
                            </select>
                        </div>
                        <div className={`${styles.formGroup}`}>
                            <label
                                htmlFor="phone"
                                className={
                                    styles.textLabel +
                                    ' ' +
                                    (formElements?.phone_number?.value.includes(
                                        '*'
                                    )
                                        ? styles.requiredField
                                        : '')
                                }
                                data-kontent-element-codename="phone_number"
                            >
                                {formElements?.phone_number?.value.replace(
                                    '*',
                                    ''
                                )}
                            </label>
                            <input
                                type="tel"
                                id="phone"
                                name="phone"
                                value={phoneNumber}
                                className={`${
                                    phoneNumberErr ? styles.errorBorder : ''
                                }`}
                                onChange={handlePhoneNumberChange}
                                maxLength={phoneNumberLength}
                                minLength={phoneNumberLength - 2}
                                ref={phoneNumberRef}
                            />
                            {phoneNumberErr &&
                                renderErrorMessage(
                                    'Number must be of 10 digits'
                                )}
                        </div>
                    </div>

                    <div className={styles.rowContainer}>
                        <div
                            className={`${styles.singleField} ${styles.formGroup}`}
                        >
                            <label
                                htmlFor="email"
                                className={
                                    styles.textLabel +
                                    ' ' +
                                    (formElements?.email?.value.includes('*')
                                        ? styles.requiredField
                                        : '')
                                }
                                data-kontent-element-codename="email"
                            >
                                {formElements?.email?.value.replace('*', '')}
                            </label>
                            <input
                                type="text"
                                id="email"
                                name="email"
                                className={`${
                                    emailErr ? styles.errorBorder : ''
                                }`}
                                title="Please enter a valid email address"
                                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                                onChange={(e) => {
                                    e.target.value.length > 0
                                        ? setEmailErr(false)
                                        : setEmailErr(true);
                                    setEmail(e.target.value);
                                }}
                                ref={emailRef}
                            />
                            {emailErr && email == ''
                                ? renderErrorMessage()
                                : emailErr && email != ''
                                ? renderErrorMessage(
                                      'E-mail address is invalid'
                                  )
                                : null}
                        </div>
                    </div>
                    <div className={styles.rowContainer}>
                        <div
                            className={`${styles.singleField} ${styles.formGroup}`}
                        >
                            <label
                                htmlFor="promocode"
                                className={styles.textLabel}
                            >
                                {
                                    formElements
                                        ?.how_did_you_hear_about_us____promo_code
                                        ?.value
                                }
                            </label>
                            <input
                                type="text"
                                id="promocode"
                                name="promoCode"
                                value={promoCode}
                                onChange={(e) => {
                                    setPromocode(e.target.value);
                                }}
                            />
                        </div>
                    </div>
                    <div className={styles.desclaimerContainer}>
                        {RichText(
                            formElements.disclaimer,
                            false,
                            undefined,
                            undefined,
                            'disclaimer'
                        )}
                    </div>

                    <div className={styles.formGroup}>
                        <input
                            type="hidden"
                            name="honeypot"
                            value={honeyPotValue}
                            onChange={(e) => setHoneyPotValue(e.target.value)}
                        />
                    </div>
                    <div className={styles.formCta}>
                        <button
                            type="submit"
                            className={styles.submitBtn}
                            id={
                                formElements
                                    .cta_configuration__cta_location_anchor_point
                                    ?.value
                            }
                            data-kontent-element-codename="cta_configuration__cta_label"
                        >
                            {formElements.cta_configuration__cta_label?.value}
                        </button>
                    </div>
                </div>
            </form>
        );
    };

    return (
        <>
            <section data-kontent-item-id={kontentItemId}>
                <div className={styles.wrapper}>
                    <div className={styles.pictureContainer}>
                        {renderImages()}

                        {textBackgroundColor && (
                            <div
                                className={styles.bgOverlay}
                                style={{
                                    backgroundColor: textBackgroundColor,
                                    opacity: textBackgroundOpacity,
                                }}
                            ></div>
                        )}
                    </div>
                    <div className={styles.content}>
                        <div className={styles.headingsContainer}>
                            {display_sub_headline?.value && (
                                <div style={{ margin: '15px 0' }}>
                                    <CustomHeadline
                                        style={
                                            subHeadlineStyle
                                                ? fetchHeadlineStyle(
                                                      subHeadlineStyle
                                                  )
                                                : 'h5'
                                        }
                                        tag={
                                            display_sub_headline_tag?.value[0]
                                                ?.codename
                                                ? display_sub_headline_tag
                                                : {
                                                      value: [
                                                          {
                                                              codename: 'h2',
                                                              name: 'h2',
                                                          },
                                                      ],
                                                  }
                                        }
                                        headline_value={display_sub_headline}
                                        alignment={{
                                            value: [{ codename: 'left' }],
                                        }}
                                        overrideStyles={{
                                            marginLeft: '0.3rem',
                                        }}
                                        elementCodename="display_sub_headline"
                                    />
                                </div>
                            )}
                            {display_headline && (
                                <div style={{ marginBottom: '15px' }}>
                                    <CustomHeadline
                                        style={'h1'}
                                        tag={
                                            display_headline_tag?.value[0]
                                                ?.codename
                                                ? display_headline_tag
                                                : {
                                                      value: [
                                                          {
                                                              codename: 'h1',
                                                              name: 'h1',
                                                          },
                                                      ],
                                                  }
                                        }
                                        headline_value={display_headline}
                                        alignment={{
                                            value: [{ codename: 'left' }],
                                        }}
                                        overrideStyles={{
                                            margin: '0px',
                                            lineHeight: '1',
                                        }}
                                        elementCodename="display_headline"
                                    />
                                </div>
                            )}
                            <div
                                style={
                                    description_copy?.value
                                        ? { margin: '15px 0' }
                                        : { margin: '15px 0', display: 'none' }
                                }
                            >
                                <CustomHeadline
                                    style={
                                        descriptionStyle
                                            ? fetchHeadlineStyle(
                                                  descriptionStyle
                                              )
                                            : 'h5'
                                    }
                                    tag={
                                        description_tag?.value[0]?.codename
                                            ? description_tag
                                            : {
                                                  value: [
                                                      {
                                                          codename: 'h2',
                                                          name: 'h2',
                                                      },
                                                  ],
                                              }
                                    }
                                    headline_value={
                                        description_copy || { value: '' }
                                    }
                                    alignment={{
                                        value: [{ codename: 'left' }],
                                    }}
                                    overrideStyles={{
                                        marginLeft: '0.25rem',
                                    }}
                                    elementCodename="description_copy"
                                />
                            </div>
                            <div className={`${styles.ctaContainer}`}>
                                <div className={styles.cta1}>
                                    {ctaShowHide ? (
                                        <CtaLink
                                            href={BuildLinkHref(
                                                cta_configuration__cta_location,
                                                cta_configuration__cta_location_anchor_point
                                            )}
                                            target={
                                                ctaWindowAction === 'new_window'
                                                    ? '_blank'
                                                    : undefined
                                            }
                                            visualStyle="outlineLight"
                                        >
                                            {
                                                cta_configuration__cta_label?.value
                                            }
                                        </CtaLink>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                        {form_headline?.value != '' && (
                            <section className={styles.formContainer}>
                                <main className={styles.formWrapper}>
                                    <h2
                                        className={styles.headline}
                                        data-kontent-element-codename="form_headline"
                                    >
                                        {form_headline?.value}
                                    </h2>

                                    {renderGetPricingForm(
                                        firstNameRef,
                                        lastNameRef,
                                        emailRef,
                                        phoneNumberRef
                                    )}
                                </main>
                            </section>
                        )}
                    </div>
                    {form_headline?.value != '' && (
                        <section className={styles.mobileFormContainer}>
                            <div className={styles.mobileFormWrapper}>
                                <h2
                                    className={styles.headline}
                                    data-kontent-element-codename="form_headline"
                                >
                                    {form_headline?.value}
                                </h2>
                                {renderGetPricingForm(
                                    mobileFirstNameRef,
                                    mobileLastNameRef,
                                    mobileEmailRef,
                                    mobileNumberRef
                                )}
                            </div>
                        </section>
                    )}
                </div>
            </section>
            <ToastContainer />
        </>
    );
};

export default FormMasthead;

export const fragmentFormMasthead = graphql`
    fragment FormMasthead on kontent_item_component___form_masthead {
        id
        elements {
            display_headline {
                value
            }
            component_anchor_name {
                value
            }
            cta_configuration__cta_label {
                value
            }
            cta_configuration__cta_location {
                ...kontentCtaLocation
            }
            cta_configuration__cta_location_anchor_point {
                value
            }
            cta_configuration__cta_window_action {
                value {
                    codename
                }
            }
            cta_show_or_hide {
                value {
                    codename
                }
            }
            display_sub_headline {
                value
            }
            display_headline_tag {
                value {
                    codename
                    name
                }
            }
            display_sub_headline_tag {
                value {
                    codename
                    name
                }
            }
            sub_headline_style {
                value {
                    codename
                    name
                }
            }
            description_style {
                value {
                    codename
                    name
                }
            }
            description_copy {
                value
            }
            general_large___small_image_selection__large {
                ...kontentImage
            }
            general_large___small_image_selection__small {
                ...kontentImage
            }
            text_background_color {
                ...kontentColor
            }
            text_background_opacity {
                value
            }
            form_headline {
                value
            }
            form {
                value {
                    ... on kontent_item_masthead_form {
                        id
                        elements {
                            disclaimer {
                                value
                            }
                            email {
                                value
                                name
                            }
                            first_name {
                                value
                                name
                            }
                            last_name {
                                value
                                name
                            }
                            phone_number {
                                value
                            }
                            select_country {
                                value
                            }
                            how_did_you_hear_about_us____promo_code {
                                name
                                value
                            }
                            cta_configuration__cta_label {
                                value
                            }
                            cta_configuration__cta_location {
                                ...kontentCtaLocation
                            }
                            cta_configuration__cta_location_anchor_point {
                                value
                            }
                            cta_configuration__cta_window_action {
                                value {
                                    codename
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
